var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgShareOnMobile(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1250_2953)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.8884 0.875H3.05878C2.44922 0.875 1.95508 1.40003 1.95508 2.04769V14.9472C1.95508 15.5949 2.44922 16.1199 3.05878 16.1199H11.8884C12.498 16.1199 12.9921 15.5949 12.9921 14.9472V2.04769C12.9921 1.40003 12.498 0.875 11.8884 0.875Z",
    stroke: "#38CB89",
    strokeWidth: 1.93148,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.9209 13.1875H8.57645",
    stroke: "#38CB89",
    strokeWidth: 1.93148,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1250_2953"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15.4519,
    height: 16.4176,
    fill: "white",
    transform: "translate(0.0239258 0.291016)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShareOnMobile);
export default __webpack_public_path__ + "static/media/share-on-mobile.cb9c19c7b52a235963aa321892d18c6a.svg";
export { ForwardRef as ReactComponent };